import React from "react";

// Permiso/confirmación aprobados desde «Actualizar desde correo» (linea.permiso_montaje + linea.cambio_grafica).
// Sólo expone información ya aprobada; compatible con rutas antiguas (sin campos → no renderiza nada).
export function tienePermisoCorreo(linea) {
  const pm = linea?.permiso_montaje || {};
  const cg = linea?.cambio_grafica || {};
  return !!(pm.hora_franja || pm.observaciones || pm.centro_autoriza || pm.fecha_autorizada || cg.quitar || cg.poner);
}

const fmtFecha = (iso) => (iso ? new Date(iso).toLocaleDateString("es-ES", { weekday: "short", day: "2-digit", month: "2-digit" }) : null);

export function PermisoCorreoBadge({ linea, testId }) {
  if (!tienePermisoCorreo(linea)) return null;
  const pm = linea.permiso_montaje || {};
  const cg = linea.cambio_grafica || {};
  return (
    <span className="text-[9px] px-1.5 py-0.5 rounded bg-sky-500/20 text-sky-100 border border-sky-500/40 font-semibold truncate max-w-[220px]" data-testid={testId}
      title="Permiso/confirmación del cliente aprobado desde correo">
      {pm.hora_franja ? `🕘 ${pm.hora_franja}` : "📩 Permiso"}{cg.quitar || cg.poner ? ` · ${cg.quitar || "?"} → ${cg.poner || "?"}` : ""}
    </span>
  );
}

export function GraficaChip({ cg, testId, className = "" }) {
  if (!cg || !(cg.quitar || cg.poner)) return null;
  return (
    <span className={`inline-flex items-center gap-1 text-[10px] font-semibold ${className}`} data-testid={testId}
      title={`Cambio de gráfica aprobado desde correo${cg.at ? ` · ${cg.at.slice(0, 10)}` : ""}${cg.por ? ` · ${cg.por}` : ""}`}>
      {cg.poner && <span className="px-1.5 py-0.5 rounded bg-emerald-500/20 text-emerald-200 border border-emerald-500/40">PONER: {cg.poner}</span>}
      {cg.quitar && <span className="px-1.5 py-0.5 rounded bg-red-500/20 text-red-200 border border-red-500/40">QUITAR: {cg.quitar}</span>}
    </span>
  );
}

export function PermisoCorreoBlock({ linea, testId }) {
  if (!tienePermisoCorreo(linea)) return null;
  const pm = linea.permiso_montaje || {};
  const cg = linea.cambio_grafica || {};
  return (
    <div className="bg-sky-500/10 border border-sky-500/40 rounded-xl p-3 space-y-1.5" data-testid={testId}>
      <div className="text-xs text-sky-200 font-semibold">📩 Permiso / confirmación del cliente (aprobado desde correo)</div>
      {(pm.hora_franja || pm.fecha_autorizada) && (
        <div className="text-base font-bold text-sky-100" data-testid={`${testId}-franja`}>
          🕘 {pm.hora_franja || "Franja no indicada"}{pm.fecha_autorizada && <span className="text-xs font-normal text-sky-200/80 ml-2">· {fmtFecha(pm.fecha_autorizada)}</span>}
        </div>
      )}
      {(cg.quitar || cg.poner) && (
        <div className="flex items-center gap-2 text-sm" data-testid={`${testId}-grafica`}>
          <span className="px-2 py-0.5 rounded bg-red-500/20 text-red-200 border border-red-500/40 font-semibold">QUITAR: {cg.quitar || "—"}</span>
          <span className="text-zinc-400">→</span>
          <span className="px-2 py-0.5 rounded bg-emerald-500/20 text-emerald-200 border border-emerald-500/40 font-semibold">PONER: {cg.poner || "—"}</span>
        </div>
      )}
      {pm.observaciones && <div className="text-xs text-sky-100/90" data-testid={`${testId}-obs`}>📝 {pm.observaciones}</div>}
      {pm.centro_autoriza && <div className="text-[10px] text-sky-200/70">Autoriza: {pm.centro_autoriza}</div>}
      {(pm.at || cg.at) && <div className="text-[9px] text-sky-200/50">Aplicado {(cg.at || pm.at).slice(0, 10)}{(cg.por || pm.por) ? ` · ${cg.por || pm.por}` : ""}</div>}
    </div>
  );
}
